import React from "react";
import {withStyles} from '@material-ui/core/styles';

import Icon from "@material-ui/core/Icon";
import InputBase from "@material-ui/core/InputBase/InputBase";

const ToolbarSearch = ({placeholder, classes}) => (
    <div className={classes.search}>
        <div className={classes.searchIcon}>
            <Icon>search</Icon>
        </div>
        <InputBase
            placeholder={placeholder}
            classes={{
                root: classes.inputRoot,
                input: classes.inputInput,
            }}
        />
    </div>
);

const styles = theme => ({
    search: {
        position: 'relative',
        marginLeft: theme.spacing.unit * 12,
        marginRight: theme.spacing.unit * 2,
        width: '100%',
    },
    searchIcon: {
        width: theme.spacing.unit * 5,
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputRoot: {
        color: 'inherit',
        width: '100%',
    },
    inputInput: {
        paddingTop: theme.spacing.unit,
        paddingRight: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        paddingLeft: theme.spacing.unit * 6,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: 200,
        },
    },
});

export default withStyles(styles)(ToolbarSearch);